import { useEffect, useRef, useState } from "react";
import { fmtH } from "../lib/hours";
import { ClientChip } from "./bits";

const TYPES = [["retainer", "Retainers"], ["project", "Projects"], ["internal", "Internal"]];

export function ClientPicker({ clients, value, hours, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [at, setAt] = useState(0);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return;
    const down = (e) => { if (!box.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("pointerdown", down);
    return () => document.removeEventListener("pointerdown", down);
  }, [open]);
  const hit = clients.filter((c) => !q || c.name.toLowerCase().includes(q.toLowerCase()) || c.code.toLowerCase().startsWith(q.toLowerCase()));
  const flat = TYPES.flatMap(([t]) => hit.filter((c) => c.type === t));
  const flip = (code) => onChange(value.includes(code) ? value.filter((x) => x !== code) : [...value, code]);
  const byCode = Object.fromEntries(clients.map((c) => [c.code, c]));
  const key = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setOpen(true); setAt(Math.min(flat.length - 1, at + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setAt(Math.max(0, at - 1)); }
    else if (e.key === "Enter" && open && flat[at]) { e.preventDefault(); flip(flat[at].code); }
    else if (e.key === "Escape" && open) { e.preventDefault(); e.stopPropagation(); setOpen(false); }
    else if (e.key === "Backspace" && !q && value.length) onChange(value.slice(0, -1));
  };
  return (
    <div className="cpick" ref={box} data-testid="export-client-picker">
      <div className="lbl">Clients</div>
      <div className="cp-box" onClick={() => { setOpen(true); box.current.querySelector("input").focus(); }}>
        {value.length === 0 && !q && <span className="cp-any">Any client</span>}
        {value.map((c) => (
          <span key={c} className="cp-tag" data-testid={`picked-${c}`}><ClientChip code={c} name={byCode[c]?.name} />{byCode[c]?.name}
            <button aria-label={`Remove ${byCode[c]?.name || c}`} onClick={(e) => { e.stopPropagation(); flip(c); }} data-testid={`unpick-${c}`}>×</button></span>))}
        <input role="combobox" aria-expanded={open} aria-controls="cp-list" aria-activedescendant={open && flat[at] ? `cp-${flat[at].code}` : undefined}
          aria-label="Filter clients" value={q} onFocus={() => setOpen(true)} onChange={(e) => { setQ(e.target.value); setAt(0); setOpen(true); }} onKeyDown={key} data-testid="export-client-search" />
        {value.length > 0 && <button className="link sm" onClick={(e) => { e.stopPropagation(); onChange([]); }} data-testid="export-client-clear">Clear</button>}
      </div>
      {open && (
        <ul id="cp-list" role="listbox" aria-multiselectable="true" className="cp-list" data-testid="export-client-list">
          {!flat.length && <li className="hint0 pad">No client matches "{q}".</li>}
          {TYPES.map(([t, l]) => { const g = hit.filter((c) => c.type === t); return g.length > 0 && [
            <li key={t} role="presentation" className="cp-g lbl">{l}</li>,
            ...g.map((c) => (
              <li key={c.code} id={`cp-${c.code}`} role="option" aria-selected={value.includes(c.code)} className={`cp-opt ${flat[at]?.code === c.code ? "at" : ""}`}
                onMouseDown={(e) => e.preventDefault()} onClick={() => flip(c.code)} data-testid={`pick-${c.code}`}>
                <span className="cp-check" aria-hidden="true">{value.includes(c.code) ? "✓" : ""}</span><ClientChip code={c.code} name={c.name} />
                <span className="trunc">{c.name}{!c.active && <em className="i2"> (inactive)</em>}</span><span className="num i2 ml-auto">{fmtH(hours[c.code] || 0)}</span></li>))]; })}
        </ul>)}
    </div>
  );
}
